export const STALE_TIME_MS = 5 * 60 * 1000; // 5 minutes
export const STALE_TIME_AUTH_MS = 30 * 1000; // 30 seconds
export const GC_TIME_MS = 30 * 60 * 1000; // 30 minutes

export const CURRENT_USER_QUERY_KEY = "currentUser";
export const COMPANIES_QUERY_KEY = "companies";

export const MAX_RETRY_ATTEMPTS = 3;
